import { useRouteLoaderData } from "@remix-run/react";
import { useMemo } from "react";
import { RepresentationType } from "../auth/determineRepresentation";
import log from "../logging/log";
import { RootLoaderData } from "./RootLoaderData";

const FALLBACK: RootLoaderData = {
  user: null,
  representation: { type: RepresentationType.Anonymous },
  useLogRocket: false,
  locale: "sv",
  ENV: { ENABLE_SENTRY: false, ENVIRONMENT: "development" },
};

export function useRootLoaderData(): RootLoaderData {
  const data = useRouteLoaderData("root");

  return useMemo(() => {
    const result = RootLoaderData.safeParse(data);

    if (result.success) {
      return result.data;
    }

    log.warn(`Invalid root loader data: ${result.error.message}`);
    return FALLBACK;
  }, [data]);
}
